import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/apps/$appId/villages')({
  component: VillagesLayout,
})

function VillagesLayout() {
  return <Outlet />
}
